import { Filter, Plus } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import SearchInput from './SearchInput';

const ModuleSearchBar = ({
    searchTerm,
    setSearchTerm,
    placeholder = "Search...",
    isFiltersVisible,
    onToggleFilters,
    onCreate, // New prop for mobile "+" button
    children,
    className = ''
}) => {
    return (
        <div className={`shrink-0 pb-0 md:h-14 flex flex-col md:flex-row items-center gap-2 md:gap-4 px-1 md:px-0 ${className}`}>
            {/* Left: Standardized Search Input + Filter Toggle */}
            <div className="flex-1 w-full flex items-center gap-3">
                <div className="flex-1">
                    <SearchInput
                        value={searchTerm}
                        onChange={setSearchTerm}
                        placeholder={placeholder}
                    />
                </div>

                {/* Mobile "+" Button */}
                {onCreate && (
                    <button
                        type="button"
                        onClick={onCreate}
                        className="md:hidden w-12 h-12 shrink-0 rounded-2xl bg-accent text-primary-dark flex items-center justify-center shadow-lg active:scale-95 transition-all"
                        title="Create New"
                    >
                        <Plus size={20} className="stroke-[3]" />
                    </button>
                )}

                {onToggleFilters && (
                    <button
                        type="button"
                        onClick={onToggleFilters}
                        className={`w-12 md:w-14 h-12 md:h-14 shrink-0 rounded-2xl border-2 transition-all flex items-center justify-center group shadow-sm ${!isFiltersVisible
                            ? 'bg-white border-transparent text-slate-400 hover:border-slate-200 hover:text-primary'
                            : 'bg-primary/5 border-primary/20 text-primary shadow-inner'
                            }`}
                        title={isFiltersVisible ? 'Hide Filters' : 'Show Filters'}
                    >
                        <Filter size={24} className={`transition-transform duration-300 ${isFiltersVisible ? 'fill-primary/10' : 'group-hover:scale-110'}`} />
                    </button>
                )}
            </div>

            {/* Right: Custom Action Slot (Buttons, KPI badges, etc.) - Hidden on mobile to save space */}
            {children && (
                <div className="hidden md:flex shrink-0 items-center gap-3 md:h-14">
                    {children}
                </div>
            )}
        </div>
    );
};

ModuleSearchBar.propTypes = {
    searchTerm: PropTypes.string.isRequired,
    setSearchTerm: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    children: PropTypes.node
};

export default React.memo(ModuleSearchBar);
